<template>
    <div class="containerI mb-5">
        <h2 class="tab-header my-0 mb-3">
            <div class=" d-flex justify-content-between align-items-center">
                <div>
                    <h4 style="color: #2D2D2D;">Proctoring</h4>
                    <h5 style="color: #888888;" class="mt-2"> Set up measures to help keep assessments fair and secure!
                        Choose options like browser lockdown, webcam
                        monitoring, or randomizing questions to minimize cheating. Let’s ensure everyone plays by the
                        rules!</h5>
                </div>
                <button @click="toggleProctorSettings()" :class="{ 'toggle-button': true, 'active': showProctorStatus }"
                    class="ms-2">
                </button>
            </div>
        </h2>
        <div v-if="showProctorStatus">
            <hr>
            <div class="row mx-3 pb-3">
                <div class="d-flex flex-row justify-content-between align-items-center">
                    <!-- <div class="d-flex align-items-center">
                    <span class="me-2">Advance Proctoring</span>
                    <button @click="advanceProctorStatus = !advanceProctorStatus"
                        :class="{ 'toggle-button': true, 'active': this.advanceProctorStatus }" class=""></button>
                </div> -->
                    <div class="toggle-row">
                        <span class="me-2">Advance Proctoring</span>
                        <button @click="advanceProctorStatus = !advanceProctorStatus"
                            :class="{ 'toggle-button': true, 'active': this.advanceProctorStatus }"></button>
                    </div>
                    <div class="d-flex align-items-center">
                        <span class="me-2">With Red Pro 5</span>
                        <button @click="redPro5ProctorStatus = !redPro5ProctorStatus"
                            :class="{ 'toggle-button': true, 'active': this.redPro5ProctorStatus }" class="">
                        </button>
                    </div>

                </div>
            
                <div v-if="isProctorValueChanged"> <button class="btn btn-primary float-end mt-2"
                        @click="updateProctorSettings">Update</button></div>
            </div>
        </div>


    </div>
    <div class="containerI" v-if="showProctorStatus">
        <h2 class="tab-header my-0">
            <div class=" d-flex justify-content-between align-items-center">
                <div>
                    <h4 style="color: #2D2D2D;">Advanced Proctoring</h4>
                    <h5 style="color: #888888;" class="mt-2"> Set up measures to help keep assessments fair and secure!
                        Choose options like browser lockdown, webcam
                        monitoring, or randomizing questions to minimize cheating. Let’s ensure everyone plays by the
                        rules!</h5>
                </div>
            </div>
        </h2>
        <hr>
        <div class="toggle-container">
            <!-- Evaluation Section -->
            <div class="proctor-card">
                <h5 class="card-title">Evaluation</h5>

                <div class="toggle-row">
                    <span>Face Detection</span>
                    <button @click="advancedProctorDetails.faceDetection = !advancedProctorDetails.faceDetection"
                        :class="{ 'toggle-button': true, active: advancedProctorDetails.faceDetection }"></button>
                </div>

                <div class="toggle-row">
                    <span>Similar Face Detection</span>
                    <button
                        @click="advancedProctorDetails.similarFaceDetection = !advancedProctorDetails.similarFaceDetection"
                        :class="{ 'toggle-button': true, active: advancedProctorDetails.similarFaceDetection }"></button>
                </div>

                <div class="toggle-row">
                    <span>Resume Activity</span>
                    <button @click="advancedProctorDetails.resumeActivity = !advancedProctorDetails.resumeActivity"
                        :class="{ 'toggle-button': true, active: advancedProctorDetails.resumeActivity }"></button>
                </div>

                <div class="toggle-row">
                    <span>Switch Check</span>
                    <button @click="advancedProctorDetails.switchCheck = !advancedProctorDetails.switchCheck"
                        :class="{ 'toggle-button': true, active: advancedProctorDetails.switchCheck }"></button>
                </div>

                <div class="toggle-row">
                    <span>Clipboard Activity</span>
                    <button
                        @click="advancedProctorDetails.clipboardActivity = !advancedProctorDetails.clipboardActivity"
                        :class="{ 'toggle-button': true, active: advancedProctorDetails.clipboardActivity }"></button>
                </div>

                <div class="toggle-row">
                    <span>IP Detection</span>
                    <button @click="advancedProctorDetails.ipDetection = !advancedProctorDetails.ipDetection"
                        :class="{ 'toggle-button': true, active: advancedProctorDetails.ipDetection }"></button>
                </div>

                <div class="toggle-row">
                    <span>AI Generated Text</span>
                    <button @click="advancedProctorDetails.aiGeneratedText = !advancedProctorDetails.aiGeneratedText"
                        :class="{ 'toggle-button': true, active: advancedProctorDetails.aiGeneratedText }"></button>
                </div>
            </div>

            <!-- Report Section -->
            <div class="proctor-card">
                <h5 class="card-title">Report</h5>

                <div class="toggle-row">
                    <span>Picture Capture</span>
                    <button @click="advancedProctorDetails.pictureCapture = !advancedProctorDetails.pictureCapture"
                        :class="{ 'toggle-button': true, active: advancedProctorDetails.pictureCapture }"></button>
                </div>

                <div class="toggle-row">
                    <span>Logs Enable</span>
                    <button @click="advancedProctorDetails.logEnable = !advancedProctorDetails.logEnable"
                        :class="{ 'toggle-button': true, active: advancedProctorDetails.logEnable }"></button>
                </div>

                <div class="toggle-row">
                    <span>Audio Enable</span>
                    <button @click="advancedProctorDetails.audioEnable = !advancedProctorDetails.audioEnable"
                        :class="{ 'toggle-button': true, active: advancedProctorDetails.audioEnable }"></button>
                </div>

                <div class="toggle-row">
                    <span>Video Enable</span>
                    <button @click="advancedProctorDetails.videoEnable = !advancedProctorDetails.videoEnable"
                        :class="{ 'toggle-button': true, active: advancedProctorDetails.videoEnable }"></button>
                </div>
            </div>
        </div>

        <div class="proctor-btns">
            <span v-if="hasChanges">
                <button class="btn btn-primary" @click="updateAdvancedProctorDetails()">Update</button>
            </span>
            <span>
                <button class="btn btn-primary" @click="getDefaultAdvancedProctorDetails">Default</button>
            </span>
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
    data() {
        return {
            routetestId: window.atob(this.$route.query.id),
            showProctorStatus: false,
            advanceProctorStatus: false,
            redPro5ProctorStatus: false,
            originalRedPro5ProctorStatus: false,
            originalAdvanceProctorStatus: false,
            originalAdvancedProctorDetails: {},
            advancedProctorDetails: {
                faceDetection: false,
                similarFaceDetection: false,
                resumeActivity: false,
                switchCheck: false,
                clipboardActivity: false,
                ipDetection: false,
                aiGeneratedText: false,
                pictureCapture: false,
                logEnable: false,
                audioEnable: false,
                videoEnable: false,
            },
        };
    },
    computed: {
        isProctorValueChanged() {
            return (this.advanceProctorStatus !== this.originalAdvanceProctorStatus) ||
                (this.redPro5ProctorStatus != this.originalRedPro5ProctorStatus)
        },
        hasChanges() {
            return JSON.stringify(this.advancedProctorDetails) !== JSON.stringify(this.originalAdvancedProctorDetails);
        }
    },
    async mounted() {
        this.getAdvancedProctorDetails();
    },
    methods: {
        ...mapActions([
            "GetAdvancedProctorDetails",
            "DefaultAdvancedProctorDetails",
            "UpdateAdvancedProctorDetails",
            "getProctorSettings",
            "putProctorSettings"
        ]),
        async getAdvancedProctorDetails() {
            var data = await this.getProctorSettings({
                testId: this.routetestId
            });
            if(data.status && data.object.data.isProctored){
                var response = await this.GetAdvancedProctorDetails({
                testId: this.routetestId
            });
            if (response.status) {

                console.log("Proctor get response 12: ", response);
                this.assignAdvancedPoctorValues(response.object.data);
            }
            }
            
        },
        assignAdvancedPoctorValues(response) {
            this.showProctorStatus = response.proctorType == "2" || response.proctorType == "3";
            this.advanceProctorStatus = response.proctorType === "3";
            this.redPro5ProctorStatus = response.videoCaptureType === "1";
            this.originalAdvanceProctorStatus = this.advanceProctorStatus;
            this.originalRedPro5ProctorStatus = this.redPro5ProctorStatus;
            this.advancedProctorDetails = {
                faceDetection: response.faceDetectionEnabled,
                similarFaceDetection: response.similarFaceDetection,
                resumeActivity: response.resumeActivity,
                switchCheck: response.switchCheckEnabled,
                clipboardActivity: response.clipboardActivity,
                ipDetection: response.ipDetection,
                aiGeneratedText: response.aiGeneratedText,
                pictureCapture: response.pictureCapture,
                logEnable: response.logsEnabled,
                audioEnable: response.audioCapture,
                videoEnable: response.videoCapture
            };

            this.originalAdvancedProctorDetails = { ...this.advancedProctorDetails };
        },
        async getDefaultAdvancedProctorDetails() {
            const response = await this.DefaultAdvancedProctorDetails({
                testId: this.routetestId,
            });
            if (response.status) {
                console.log("default response:", response);
                this.assignAdvancedPoctorValues(response.object.data);
            }
        },
        async toggleProctorSettings() {
            this.showProctorStatus = !this.showProctorStatus;
            if (this.showProctorStatus == true) {
                await this.putProctorSettings({
                    testId: this.routetestId,
                    IsProctored: true,
                    webProctor: true,
                    videoProctor: false,
                    pictureCapture: true,
                    videoCapture: false,
                    audioCapture: false,
                    logsEnabled: true,
                    videoCaptureType: "2",
                    proctorType: "2"
                })
            }
            else {
                await this.putProctorSettings({
                    testId: this.routetestId,
                    IsProctored: false,
                    webProctor: false,
                    videoProctor: false,
                    pictureCapture: false,
                    videoCapture: false,
                    audioCapture: false,
                    logsEnabled: false,
                    videoCaptureType: "0",
                    proctorType: "0"
                })
            }
            this.getAdvancedProctorDetails();
        },
        async updateProctorSettings() {
            await this.putProctorSettings({
                testId: this.routetestId,
                IsProctored: this.showProctorStatus,
                webProctor: this.showProctorStatus,
                videoProctor: false,
                pictureCapture: this.showProctorStatus,
                videoCapture: false,
                audioCapture: false,
                logsEnabled: this.showProctorStatus,
                videoCaptureType: this.redPro5ProctorStatus ? "1" : "2",
                proctorType: this.advanceProctorStatus ? "3" : "2",
            })
            this.getAdvancedProctorDetails();
        },
        async updateAdvancedProctorDetails() {
            const response = await this.UpdateAdvancedProctorDetails({
                testId: this.routetestId,
                faceDetectionEnabled: this.advancedProctorDetails.faceDetection,
                similarFaceDetection: this.advancedProctorDetails.similarFaceDetection,
                resumeActivity: this.advancedProctorDetails.resumeActivity,
                switchCheckEnabled: this.advancedProctorDetails.switchCheck,
                clipboardActivity: this.advancedProctorDetails.clipboardActivity,
                ipDetection: this.advancedProctorDetails.ipDetection,
                aiGeneratedText: this.advancedProctorDetails.aiGeneratedText,
                pictureCapture: this.advancedProctorDetails.pictureCapture,
                logsEnabled: this.advancedProctorDetails.logEnable,
                audioCapture: this.advancedProctorDetails.audioEnable,
                videoCapture: this.advancedProctorDetails.videoEnable
            });
            if (response.status) {
                console.log("Update successful:", response);
                this.assignAdvancedPoctorValues(response.object.data);
            }
        }
    },
};
</script>

<style>
.containerI {
    width: 100%;
    margin: 0 auto;
    background: white;
    border-radius: 2px;
    border-color: #dee2e6;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    overflow: hidden;
    /* overflow: visible; */
}

hr {
    border-bottom: 1px solid gray;
}

.toggle-container {
    display: flex;
    gap: 2rem;
    padding: 0 .5rem;
    flex-wrap: wrap;
    width: 100%;
    box-sizing: border-box;
    justify-content: space-between;
}

.proctor-card {
    background: #fff;
    border-radius: 2px;
    padding: 1rem;
    flex: 1 1 45%;
    min-width: 300px;
    max-width: 100%;
    border-color: #dee2e6;
    box-sizing: border-box;
    /* box-shadow: 0 0 10px rgba(0, 0, 0, 0.05); */
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);

}

/* .proctor-card:hover{
    border-color: #d1d5d9;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) ;
} */

.card-title {
    font-weight: bold;
    margin-bottom: 1rem;
    border-bottom: 1px solid #ccc;
    padding-bottom: 0.5rem;
}

.toggle-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.6rem 0;
}

.toggle-button {
    width: 52px;
    min-width: 52px;
    height: 28px;
    background-color: #ccc;
    border: none;
    border-radius: 16px;
    cursor: pointer;
    position: relative;
    transition: background-color 0.3s;
}

.toggle-button::before {
    content: '';
    position: absolute;
    top: 2px;
    left: 2px;
    width: 24px;
    height: 24px;
    background-color: #fff;
    border-radius: 50%;
    transition: transform 0.3s;
}

.toggle-button.active {
    background-color: #7b68ee;
}

.toggle-button.active::before {
    transform: translateX(100%);
}

.toggle-button:disabled {
    background-color: grey;
    cursor: not-allowed;
}

.proctor-btns {
    display: flex;
    gap: .5rem;
    justify-content: flex-end;
    /* float: right; */
    margin: .5rem;
}
</style>